import { ChartClickInteraction } from '@components/Widgets/types';
import { HeadCellType } from '@fabric-ui/components/Table';
import { NullValues } from '../../../../constants';
import { SortDir } from '../../../../types';

export const getSortedDimColumnsByDate = (dims, dir: SortDir) =>
  dims.toSorted(({ value: value1 }, { value: value2 }) =>
    dir === SortDir.ASC ? new Date(value1).getTime() - new Date(value2).getTime() : new Date(value2).getTime() - new Date(value1).getTime()
  );
export const getSortedDimColumnsAlphabetically = (dims, dir: SortDir) =>
  dims.toSorted(({ value: value1 }, { value: value2 }) => {
    if (dir === SortDir.ASC) {
      return NullValues.includes(value2) ? -1 : value2.localeCompare(value1);
    }
    return NullValues.includes(value1) ? 1 : value1.localeCompare(value2);
  });

export const checkIfClickInteractionsEnabled = (
  metricsSet: Set<string>,
  cellId: string,
  clickInteractions: ChartClickInteraction[] | undefined
): clickInteractions is ChartClickInteraction[] =>
  metricsSet.has(cellId) && !!clickInteractions?.length && clickInteractions.some(v => v.isEnabledForCell({ dataKey: cellId }));

export const getSortingDir = ({
  headCells,
  selectedId,
  selectedOptions,
}: {
  headCells: HeadCellType[];
  selectedId: string;
  selectedOptions?: {
    group: string;
  };
}) =>
  selectedOptions
    ? headCells.find(({ id, options }) => id === selectedId && options?.group === selectedOptions.group)?.sort
    : headCells.find(({ id }) => id === selectedId)?.sort;
